const CURRENCY_SYMBOL_TO_CODE: Record<string, string> = {
  $: "USD",
  "€": "EUR",
  "£": "GBP",
  "¥": "JPY",
}

const normalizeCurrencyCode = (currency: string): string => {
  const trimmed = currency.trim()
  return CURRENCY_SYMBOL_TO_CODE[trimmed] ?? trimmed.toUpperCase()
}

export const formatPrice = (price: number | null, currency: string | null): string => {
  const parsedPrice = typeof price === 'string' ? parseFloat(price) : price
  if (parsedPrice === null || !currency) return "-"
  const amount = parsedPrice / 100
  const code = normalizeCurrencyCode(currency)
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: code,
    }).format(amount)
  } catch {
    return `${currency.trim()}${amount.toFixed(2)}`
  }
}
